var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcgSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2172 11.2711H22.3V12.4711H16.5352L16.3609 12.1781L14.6563 9.32109L11.2531 17.3219L8.35938 12.4711H4.7V11.2711H9.04063L9.21563 11.5633L11.0727 14.6773L14.4766 6.67813L17.2172 11.2711Z",
    fill: "#FF9800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 22.8V24H3.1V22.8H20.7ZM21.1 22.4V1.6C21.1 1.37909 20.9209 1.2 20.7 1.2H3.1C2.87909 1.2 2.7 1.37909 2.7 1.6V22.4C2.7 22.6209 2.87909 22.8 3.1 22.8V24L2.93672 23.9914C2.18348 23.915 1.58496 23.3165 1.50859 22.5633L1.5 22.4V1.6C1.5 0.716344 2.21634 3.22128e-08 3.1 0H20.7C21.5837 0 22.3 0.716344 22.3 1.6V22.4C22.3 23.2285 21.6702 23.9096 20.8633 23.9914L20.7 24V22.8C20.9209 22.8 21.1 22.6209 21.1 22.4Z",
    fill: "#FF9800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcgSquare);
export default __webpack_public_path__ + "static/media/ecg-square.dd19a21277bb24364d316e2d652bc6f2.svg";
export { ForwardRef as ReactComponent };